module.exports = __webpack_public_path__ + "img/home-active.4cd3346f.svg";